import React from "react";

const Footer = () => <>{/* footers are for dorks */}</>;

export default Footer;
